import TiLogo  from "./Images/Transportation-Insight-logo.svg"
import EfsLogo from "./Images/EFS-HD-LOGO.svg"
import JBHLogo from "./Images/JBHUNT-logo.svg"
import CGTSLogo from "./Images/CGTS-logo.svg"
import SATLogo  from "./Images/SAT-logo.svg"
 import MOTOLogo from "./Images/MOTO-logo.png"
import TCLLogo from "./Images/TCL-logo.png"
import ALLogo from "./Images/ALLogo.svg";

const freightForwarder = ["usff@klearnow.com", "ukff@klearnow.com", "caff@klearnow.com", "nlff@klearnow.com", "esff@klearnow.com", "demo@klearnow.com", "alok.sinha@klearexpress.com"]

const loginAsAccounts = ["usff@klearnow.com", "ukff@klearnow.com", "caff@klearnow.com", "nlff@klearnow.com", "esff@klearnow.com"];

export const getWhiteLabelCustomerName = () =>{
    if (window.location.hostname === "ti.dev.klearnow.com" || window.location.hostname === "ti.stage.klearnow.com" || window.location.hostname === "ti.klearnow.com" || window.location.hostname === "ti-pre.klearnow.com") {
       return "TI"
    } else if(window.location.hostname === "jbh.dev.klearnow.com" || window.location.hostname === "jbh.stage.klearnow.com" || window.location.hostname === "jbh.klearnow.com" || window.location.hostname === "jbh-pre.klearnow.com"){
        return "JBH"
    } else if (window.location.hostname === "cgts.dev.klearnow.com" || window.location.hostname === "cgts.stage.klearnow.com" || window.location.hostname === "cgtradeservices.klearnow.com" || window.location.hostname === "cgtradeservices-pre.klearnow.com"){
        return "CGTS"
    } else if (window.location.hostname === "sat.dev.klearnow.com" || window.location.hostname === "sat.stage.klearnow.com" || window.location.hostname === "sat.klearnow.com" || window.location.hostname === "sat-pre.klearnow.com"){
        return "SAT"
    } else if (window.location.hostname === "moto.dev.klearnow.com" || window.location.hostname === "moto.stage.klearnow.com" || window.location.hostname === "moto.klearnow.com" || window.location.hostname === "moto-pre.klearnow.com"){
        return "MOTO"
    } else if (window.location.hostname === "tcn.dev.klearnow.com" || window.location.hostname === "tcn.stage.klearnow.com" || window.location.hostname === "tcn.klearnow.com" || window.location.hostname === "tcn-pre.klearnow.com"){
        return "TCL"
    } else if (window.location.hostname === "activelogistics.dev.klearnow.com" || window.location.hostname === "activelogistics.stage.klearnow.com" || window.location.hostname === "activelogistics.qat.klearnow.com" || window.location.hostname === "activelogistics.klearnow.com" || window.location.hostname === "activelogistics-pre.klearnow.com"){
        return "AL"
    }
    
    return ""
}

export const loginAsAccess = (email) => {
    if(loginAsAccounts.includes(email)){
        return true;
    }
    return false;
}

export const freightForwarderAccess = (kxEmail) => {
    if(freightForwarder.includes(kxEmail)){
        return true;
    }
    return false;
}

const checkEnv = () => {
    let URL = window._env_.REACT_APP_API_URL;
    let env = URL.split('/');
    env = env[3];
    env = env.replace('-cust', '');

    if(["staging",'pre-prod',"dev", "qat"].includes(env)){
      return false;
    }
    return true;
  }

export const OTP_TESTING = checkEnv();
  
export const getWlTitleName = (wlCustomerName) =>{
   if (wlCustomerName === "TI") {
       return "TI Inc."
    }
    else if (wlCustomerName === "JBH") {
        return "JBH"
    }
    else if (wlCustomerName === "CGTS") {
        return "CGTS"
    } else if (wlCustomerName === "SAT") {
        return "SAT"
    }
    else if (wlCustomerName === "MOTO"){
        return "MOTO"
    }
    else if (wlCustomerName === "TCL"){
        return "Trans-Continental Logistics Corp."
    }
    else if (wlCustomerName === "AL"){
        return "Active Logistics"
    }


    return ""
}  


let whitelabelVars = new Map()



whitelabelVars["EFS"] = {
   
    "backgroundColor": "#AF1F24",
    "primaryColor" : "#AF1F24",
    "flex-container" : "flex-container-efs",
    "mainContainer" : "efsMainContainer",
    "rs-container" : "rs-container-efs",
    "logo": EfsLogo,
     "logoClassName":"efs-logo",
     "login-button-class" : "login-button-efs"
}

whitelabelVars["TI"] = {
    "backgroundColor" :  "#236092",
    "primaryColor": "#FFC629",
    "flex-container" : "flex-container-ti", 
    "mainContainer" : "tiMainContainer",
    "rs-container"  :  "rs-container-ti",
    "logo": TiLogo,
    "logoClassName":"ti-logo",
    "login-button-class" : "login-button-ti"
}

whitelabelVars["JBH"] = {
    "backgroundColor" :  "#236092",
    "primaryColor": "#FFC629",
    "flex-container" : "flex-container-jbh", 
    "mainContainer" : "jbhMainContainer",
    "rs-container"  :  "rs-container-jbh",
    "logo": JBHLogo,
    "logoClassName":"jbh-logo",
    "login-button-class" : "login-button-jbh"
}
whitelabelVars["CGTS"] = {
    "backgroundColor" :  "#045685",
    "primaryColor": "#FFC629",
    "flex-container" : "flex-container-cgts", 
    "mainContainer" : "cgtsMainContainer",
    "rs-container"  :  "rs-container-cgts",
    "logo": CGTSLogo,
    "logoClassName":"cgts-logo",
    "login-button-class" : "login-button-cgts",
}
whitelabelVars["SAT"] = {
    "backgroundColor" :  "#045685",
    "primaryColor": "#045685",
    "flex-container" : "flex-container-sat", 
    "mainContainer" : "satMainContainer",
    "rs-container"  :  "rs-container-sat",
    "logo": SATLogo,
    "logoClassName":"sat-logo",
    "login-button-class" : "login-button-sat",
    // "backgroundImage":"linear-gradient(225.29deg, #78216C 0%, #392A6D 44.36%, #51ABD8 100%)",
}
whitelabelVars["MOTO"] = {
    "backgroundColor" : "#559341",
    "primaryColor" : "#559341",
    "flex-container" : "flex-container-moto",
    "mainContainer" : "motoMainContainer",
    "rs-container" : "rs-container-moto",
    "logo" : MOTOLogo,
    "logoClassName" : "moto-logo",
    "login-button-class" : "login-button-moto"
}

whitelabelVars["TCL"] = {
    "backgroundColor" : "#559341",
    "primaryColor" : "#559341",
    "flex-container" : "flex-container-tcl",
    "mainContainer" : "tclMainContainer",
    "rs-container" : "rs-container-tcl",
    "logo" : TCLLogo,
    "logoClassName" : "tcl-logo",
    "login-button-class" : "login-button-tcl"
}

whitelabelVars["AL"] = {
    "backgroundColor" : "#559341",
    "primaryColor" : "#559341",
    "flex-container" : "flex-container-al",
    "mainContainer" : "alMainContainer",
    "rs-container" : "rs-container-al",
    "logo" : ALLogo,
    "logoClassName" : "al-logo",
    "login-button-class" : "login-button-al"
}

export const isWhiteLabel = () => {
    return getWhiteLabelCustomerName().length > 0
}

export const getWlLoginButtonClass = (wlCustomerName) => {
    return whitelabelVars[wlCustomerName]["login-button-class"]
}

export const getWlFlexContaier = (wlCustomerName) => {
    return whitelabelVars[wlCustomerName]["flex-container"]
}

export const getWlMainContaier = (wlCustomerName) => {
    return whitelabelVars[wlCustomerName]["mainContainer"]
}

export const getWlBackGroundColor = () => {
    return whitelabelVars[getWhiteLabelCustomerName()]["backgroundColor"]
}
export const getRightSideContainer = () => {
    return whitelabelVars[getWhiteLabelCustomerName()]["rs-container"]
}

export const wlGetPrimaryColor = (customer) => {
    if(!whitelabelVars[customer]) {
        return "#FFCCDD";
    }
    return whitelabelVars[customer]["primaryColor"]
}

export const wlGetLogoImage =()=>{
    return  whitelabelVars[getWhiteLabelCustomerName()]["logo"]
}

export const wlGetLogoClassName =()=>{
    return  whitelabelVars[getWhiteLabelCustomerName()]["logoClassName"]
}

export const  inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export const WHITELABEL_SUBDOMAINS = [
    "ti.klearnow.com", "jbh.klearnow.com", "cgts.klearnow.com", "cgtradeservices.klearnow.com", "sat.klearnow.com", "moto.klearnow.com", "tcn.klearnow.com", "activelogistics.klearnow.com"
];
  